import {
	EventBus
} from "../scripts/_eventBus.js";

const _modals = {
	show: (name) => {
		EventBus.$emit(`show:${name}`, true);
	},
	hide: (name) => {
		EventBus.$emit(`show:${name}`, false);
	}
}

const ModalPlugin = {
	install(Vue) {
		Vue.prototype.$modals = _modals;
	}
}

export default ModalPlugin;